import moment from 'moment'
import Constants from '@/utils/Constants'
import Errors from '@/utils/Errors'

export default {
  /**
   * jsonbのFileオブジェクトの形式に整形して返す
   * @params {Object} fileObj v1FileListGetで取得したFile情報
   */
  formatFile (fileObj) {
    let data = {
      fileName: fileObj.fileName,
      contentType: fileObj.fileContentsType,
      fileUri: fileObj.fileUri,
      fileSize: fileObj.fileSize
    }
    if (fileObj.thumbnailUri)
      data.thumbnailUri = fileObj.thumbnailUri
    return data
  },

  /**
   * GETで取得したファイルデータと、
   * ファイルセレクターで取得したファイルデータを比較して登録データを返す
   */
  requestFile (origin, input) {
    if (origin) {
      return origin === input ?
        origin : input
    } else {
      return input
    }
  },

  createObject (key, index) {
    switch (key) {
      case 'File':
        return {
          fileName: null,
          contentType: null,
          fileUri: null,
          fileSize: 0,
          thumbnailUri: null
        }
      case 'EnqueteAnswer':
        return {
          answerNo: index + 1,
          answerMessage: null,
          iconFile: null
        }
      case 'OrdertakeBtn':
        return {
          defaultFocusFlg: 0,
          btnName: null,
          iconFile: null,
          labelText: null,
          assignedKey: ''
        }
      case 'LinkUrl':
        return {
          name: null,
          dataSourceType: '',
          parameters: null,
          pdfFile: null
        }
    }
  },

  /**
   * Jsonbのuuidを生成
   */
  createUuid (keys, suffix) {
    const prefix = keys.map(key => key).join('-')
    const stamp = (new Date()).getTime().toString(16)
    const random = (Math.floor(Math.random() * 10000) + 10000).toString(16)
    return suffix === undefined
      ? prefix + '-' + stamp + '-' + random
      : prefix + '-' + stamp + '-' + random + '-' + suffix
  }
}
